import { find } from 'lodash';
var state = {
    all: [],
    map: {},
};
var getters = {
    all: function (state) { return state.all; },
    forItem: function (state) { return function (itemId) {
        var exception = find(state.all, function (exception) {
            return exception.parentId === itemId;
        });
        return exception;
    }; }
};
var actions = {
    setOptionExceptions: function (_a, optionExceptions) {
        var commit = _a.commit;
        commit('setOptionExceptions', optionExceptions);
    },
};
var mutations = {
    setOptionExceptions: function (state, optionExceptions) {
        state.all = optionExceptions;
        optionExceptions.forEach(function (optionException) {
            var optionExceptionKey = optionException.parentId + "-" + optionException.id;
            state.map[optionExceptionKey] = optionException;
        });
    },
};
export default {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
};



//////////////////
// WEBPACK FOOTER
// ./src/stores/modules/item.option.exception.store.ts
// module id = null
// module chunks = 